import BaseEnumType from "../../common/base-enum-type";

const FieldAreaType = Object.freeze({
    EndZone: new BaseEnumType("endZone", "End Zone"),
    NoRunZone: new BaseEnumType("noRunZone", "No Running Zone"),
    RedZone: new BaseEnumType("redZone", "Red Zone"),
    Custom: new BaseEnumType("custom", "Custom")
});

export default FieldAreaType;
